<template>
    <div class="question-single-header pt-40px pb-40px position-relative">
        <el-icon class="wrapper-shape"><QuestionFilled /></el-icon>
        <div class="container">
            <div class="row align-center">
                <div class="col-md-9">
                    <div class="question-single-header-content">
                        <h1 v-if="title">{{title}}</h1>
                        <div class="question-single-header-meta d-flex align-center flex-wrap">
                            <span class="asked">Asked <span>today</span></span>
                            <span class="modified">Modified <span>today</span></span>
                            <span class="viewed">Viewed <span>9 times</span></span>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 text-right">
                    <div class="question-single-header-right">
                        <ask-question />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AskQuestion from '../AskQuestion.vue'
import {QuestionFilled} from '@element-plus/icons-vue'

export default {
    name: 'QuestionSingleHeader',
    props: ['title', 'askedDate', 'modifiedDate', 'viewedTimes'],
    components: {
        AskQuestion,
        QuestionFilled
    },
    data() {

        return {

        }
    }
}
</script>